import React, { useEffect, useState } from 'react';
import axios from 'axios';


function useAdminMode() {
  try {
    const saved = localStorage.getItem('admin_user');
    if (saved) {
      const user = JSON.parse(saved);
      return user && user.email === 'leibold@gmail.com';
    }
  } catch {}
  return false;
}

const Leaderboard = ({ selectedTable, isAdmin: isAdminProp, isTypeVisible }) => {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [modalMessage, setModalMessage] = useState('');
  const baseUrl = 'https://pinballscoresapp-ayd8babtd4fpadec.eastus2-01.azurewebsites.net';
  const isAdminHook = useAdminMode();
  const isAdmin = isAdminProp !== undefined ? isAdminProp : isAdminHook;

  useEffect(() => {
    if (selectedTable) {
      setLoading(true);
      const decodedTableName = decodeURIComponent(selectedTable).replace(/&amp;/g, '&');
      axios.get(`${baseUrl}/api/leaderboard?table=${encodeURIComponent(decodedTableName)}`)
        .then(res => {
          setScores(res.data);
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching leaderboard:', err);
          setLoading(false);
        });
    }
  }, [selectedTable]);

  const confirmAndExecute = (action, message) => {
    setConfirmAction(() => action);
    setModalMessage(message);
    setModalVisible(true);
  };

  const deleteScore = async (scoreId) => {
    try {
      await axios.delete(`${baseUrl}/api/scores/${scoreId}`);
      setScores(scores.filter(score => score.ScoreID !== scoreId));
    } catch (err) {
      console.error('Failed to delete score', err);
    }
  };

  const handleVerify = async (scoreId) => {
    try {
      await axios.put(`${baseUrl}/api/scores/${scoreId}`, {
        isVerified: true
      });
      setScores(prevScores =>
        prevScores.map(score =>
          score.ScoreID === scoreId ? { ...score, IsVerified: true } : score
        )
      );
    } catch (err) {
      console.error('Failed to verify score', err);
    }
  };

  const renderFormattedName = (name) => {
    if (!name) return null;
    const parts = name.split('&');
    if (parts.length === 1) return name;
    return parts.map((part, i) => (
      <React.Fragment key={i}>
        {part}
        {i < parts.length - 1 && (
          <span style={{ color: '#888', fontWeight: 'normal', opacity: 0.75, margin: '0 2px' }}>&</span>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div className="leaderboard">
      {selectedTable && <h3>Showing scores for: {renderFormattedName(selectedTable)}</h3>}
      {loading ? (
        <div className="small-spinner"></div>
      ) : scores.filter(score => isTypeVisible ? isTypeVisible(score.Type) : true).length > 0 ? (
        <table className="score-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Player</th>
              <th>Score</th>
              <th>Version</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {scores.filter(score => isTypeVisible ? isTypeVisible(score.Type) : true).map((score, index) => {
              const scoreDate = new Date(score.DatePlayed);
              const oneWeekAgo = new Date();
              oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
              const isNew = scoreDate >= oneWeekAgo;

              return (
                <tr key={score.ScoreID} className={isNew ? 'new-row' : ''}>
                  <td>{index + 1}</td>
                  <td>{score.Initials}</td>
                  <td>
                    {isNew && <span className="new-tag">*New* </span>}
                    {Number(score.Score).toLocaleString()}
                  </td>
                  <td>{score.Type}</td>
                  <td>
                    {scoreDate.toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      timeZone: 'UTC'
                    })}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      {score.IsVerified && (
                        <span title="Verified Score">✅</span>
                      )}
                      {score.ProofUrl && (
                        <a
                          href={score.ProofUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="View Proof Image"
                          style={{ textDecoration: 'none' }}
                        >
                          🖼️
                        </a>
                      )}
                      {isAdmin && (
                        <>
                          {!score.IsVerified && (
                            <span
                              onClick={() =>
                                confirmAndExecute(
                                  () => handleVerify(score.ScoreID),
                                  "Are you sure you want to verify this score?"
                                )
                              }
                              title="Mark as Verified"
                              style={{ cursor: 'pointer' }}
                            >
                              ✔️
                            </span>
                          )}
                          <span
                            onClick={() =>
                              confirmAndExecute(
                                () => deleteScore(score.ScoreID),
                                "Are you sure you want to delete this score?"
                              )
                            }
                            title="Delete Score"
                            style={{ cursor: 'pointer' }}
                          >
                            🗑️
                          </span>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        selectedTable && <p>No scores found for this table.</p>
      )}

      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{modalMessage}</p>
            <button onClick={() => { confirmAction(); setModalVisible(false); }}>Yes</button>
            <button onClick={() => setModalVisible(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Leaderboard;